import * as Yup from "yup";
import "yup-phone";

export default Yup.object().shape({
  customer_name: Yup.string().required("Required"),
  // customer_phone: Yup.string()
  //   .required("Phone Number is Required")
  //   .test("is-valid-phone", "Must be a valid phone number!", (value) =>
  //     Yup.string().phone().isValidSync(value)
  //   ),
  customer_phone: Yup.string()
    .matches(/^[0-9]+$/, "Phone number must contain only numbers")
    .min(8, "Phone number must be at least 8 characters long")
    .required("Phone number is required"),
  customer_email: Yup.string().email("Invalid Email").required("Required"),
  customer_birthday: Yup.string().required("Birthday is required"),
});
